import { connect } from 'umi';
import { Layout } from 'tea-component';
import React from 'react';
import useLanguage from '@op/hooks/useLanguage';
import ContentBody from '@op/components/ContentBody';
import DataPerformance from './Component/DataPerformance';
import FeedbackAnalysis from './Component/FeedbackAnalysis';
import ChannelPerformanceTrend from './Component/ChannelPerformanceTrend';
import Calendar from './Component/Calendar';
import './index.scss';
import { useEffectiveTimeList } from './hooks/useEffectiveTimeList';
import CardCommon from '@op/components/CardCommon';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import { WeeklyReportOfficialAccountsPerformance } from '@op/operationLog/pages'; 
import WeeklyReportDateSelect from '../components/WeeklyDateSelect';
import { useAccountFilterList } from './hooks/useAccountFilterList';
import { PAGE_NAME } from '@op/constants/page';

const { Content } = Layout;

function OfficialAccountsPerformance({ gameInfo, wholeGameInfo }: any) {
  useInitBuriedPointInfo({
    buriedPoint: WeeklyReportOfficialAccountsPerformance,
  });
  const { formatMessage } = useLanguage();

  const {
    effectiveTime,
    setEffectiveTime,
    effectiveTimeList,
    defaultTime,
    loading,
    filter,
  } = useEffectiveTimeList({ gameInfo, wholeGameInfo });
  const { accountFilterOptions, defaultSelectAccount, accountFilterLoading } =
    useAccountFilterList({ filter, gameInfo });
  return (
    <Content className="dbo-page dbo-version-performance">
      <ContentBody
        className="dbo-version-performance-body"
        pageName={PAGE_NAME.OFFICIAL_ACCOUNTS_PERFORMANCE}
        contentHeard={
          <Content.Header
            title={formatMessage(PAGE_NAME.OFFICIAL_ACCOUNTS_PERFORMANCE)}
          ></Content.Header>
        }
      >
        <CardCommon
          loading={accountFilterLoading || loading}
          loadingHeight={350}
          contentCard
          empty={effectiveTimeList.length === 0}
        >
          <>
            {/* 时间选择器 */}
            <div className="dbo-accounts-filter">
              <WeeklyReportDateSelect
                defaultValue={effectiveTime}
                onChange={(value: any) => {
                  setEffectiveTime(value);
                }}
                options={effectiveTimeList}
              ></WeeklyReportDateSelect>
            </div>
            {/* 发布日历 */}
            <Calendar defaultValue={defaultTime}></Calendar>
            {/* 官号用户反馈分析 */}
            <FeedbackAnalysis
              filter={filter}
              gameInfo={gameInfo}
            ></FeedbackAnalysis>
            {/* 官号数据表现 */}
            <DataPerformance
              filter={filter}
              gameInfo={gameInfo}
              accountFilterOptions={accountFilterOptions}
              defaultSelectAccount={defaultSelectAccount}
            ></DataPerformance>
            {/* 官号分渠道表现趋势 */}
            <ChannelPerformanceTrend
              filter={filter}
              gameInfo={gameInfo}
              accountFilterOptions={accountFilterOptions}
              defaultSelectAccount={defaultSelectAccount}
            ></ChannelPerformanceTrend>
          </>
        </CardCommon>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(OfficialAccountsPerformance);
